// extracted by mini-css-extract-plugin
module.exports = {"wrap":"Backdrop_wrap__hhm37","white":"Backdrop_white__1iMuu"};